var map = {
	"./clearsale.svg": 484,
	"./ee.svg": 2108,
	"./figma.svg": 610,
	"./github.svg": 7863,
	"./instagram.svg": 3866,
	"./linkedin.svg": 9020,
	"./montehermom.svg": 7775,
	"./puc-rio.svg": 3243,
	"./sesc.svg": 7572,
	"./uerj.svg": 3360,
	"./whatsapp.svg": 1004
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6330;